import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import Card from 'components/Card';
import isIfiPhase from '../../../components/ifiUtils';
import S from '../styles.scss';

const WelcomeCallScript = (props) => {
  const { title, customerAnswered, phase } = props;
  const didAnswer = customerAnswered === 'yes';
  const isWaitingForProduct = phase.status === 'waiting_for_product';
  const isIfi = isIfiPhase(phase);
  const surfaceName = (phase.surface_type && phase.surface_type.name) || '';
  const millwork = (phase.phase_specific && phase.phase_specific.millwork_specifics) || {};
  const isDoorType = surfaceName.toLowerCase().includes('door');
  const millworkCount = isDoorType ? millwork.num_doors : millwork.num_windows;
  const pluralizedSurface = millworkCount !== 1 && !surfaceName.toLowerCase().endsWith('s')
    ? `${surfaceName}s`
    : surfaceName;

  return (<Card className={S.card}>
    <div className={S.headerContainer}>
      <h4 className={S.title}>
        {`${title} ${didAnswer ? 'Answered' : 'Voicemail'}`} Script
      </h4>
    </div>
    <div className={S.scriptContainer}>
      {didAnswer ? (<Fragment>
        <p>
          If you have just one moment, I would like to go over the process
          for your project and ensure that you have all the information you need
          for a successful installation. Is now a good time?
        </p>
        <br />
        <p>
          I see that we are installing{' '}
          {isIfi ? (
            <span className={S.scriptText}>{millworkCount} {pluralizedSurface}</span>
          ) : (<Fragment>
            <span className={S.scriptBlank}>__</span>{' '}
            <strong>(specify the doors/windows)</strong>{' '}
            <span className={S.scriptBlank}>__</span>
          </Fragment>)}. Is that correct?
        </p>
        <br />
        {isWaitingForProduct ? (<Fragment>
          <p>
            At this time, we are waiting for your material to arrive. Once it
            arrives, Contractor will be notified to schedule your installation.
            We want to communicate in a way that works best for you throughout
            your project.
          </p>
          <br />
          <p>What number is best to reach you?</p>
          <br />
          <p>
            OK, and to make sure I have it right, I
            heard <span className={S.scriptText}>___</span>.
          </p>
        </Fragment>) : (<Fragment>
          <p>
            Lowe{'\''}s has confirmed that all materials have been received and
            your project is ready to schedule. We have notified our subcontractor
            who will be completing the installation, they will reach out to you
            within 48 business hours to offer our soonest available date.
          </p>
          <br />
          <p>What number would you like us to contact you on?</p>
          <br />
          <p>
            OK, and to make sure I have it
            right, <span className={S.scriptText}>___</span> is the best number?
          </p>
        </Fragment>)}
        <br />
        <p>
          I would also like to ensure that you have our number for any questions
          or concerns throughout your project. I can text that number to you,
          or if you{'\''}re able to write it down I can read that to you over
          the phone. Our number is 833-377-2712. Our office is open from 7am
          to 6pm, Monday through Friday. And 8am to 5pm on Saturdays.
        </p>
        <br />
        <p>Do you have any questions for me at this time?</p>
        <br />
        <p>Thank you for your purchase. We look forward to working with you.</p>
      </Fragment>) : (<Fragment>
        {isWaitingForProduct ? (<Fragment>
          <p>
            At this time, we are waiting for your material to arrive. Once it
            arrives, our Contractor will be notified to schedule your
            installation. I would also like to ensure that you have our phone
            number for any questions or concerns throughout your installation.
            Our number is 833-377-2712. Our office is open from 7am to 6pm,
            Monday through Friday. And 8am to 5pm on Saturdays.
          </p>
          <br />
          <p>
            If you have any questions or if any of the information was not
            correct, please contact us at your convenience.
          </p>
        </Fragment>) : (<Fragment>
          <p>
            I wanted to go over the process for your project
            and ensure that you have all the information you need for a
            successful installation.
          </p>
          <br />
          <p>
            Lowe{'\''}s has confirmed that all materials have been received
            and your project is ready to schedule. Our subcontractor will be
            reaching out to you within 48 business hours to offer our soonest
            available date. I would also like to ensure that you have our phone
            number for any questions or concerns throughout your installation.
            Our number is 833-377-2712. Our office is open from 7am to 6pm,
            Monday through Friday. And 8am to 5pm on Saturdays.
          </p>
          <br />
          <p>Do you have any questions for us at this time?</p>
        </Fragment>)}
        <br />
        <p>Thank you for your purchase. We look forward to working with you.</p>
      </Fragment>)}
    </div>
  </Card>);
};

WelcomeCallScript.propTypes = {
  title: PropTypes.string,
  customerAnswered: PropTypes.string,
  phase: PropTypes.object,
};

export default WelcomeCallScript;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseCommunications/components/welcomeCallScript.jsx